import { BillableItemAssociation, MixDesignLineItem, ModelObject } from '@cco/model';

export interface MixDesign extends ModelObject<number> {
  name: string;
  designStrength: number;
  designStrengthUnitId: number;
  designAge: number;
  waterCementiousRatio?: number;
  exposureClassId?: number;
  lineItems: MixDesignLineItem[];
  slumpTarget: number;
  slumpVariation: number;
  slumpUnitId: number;
  airContentTarget: number;
  airContentVariation: number;
  comments: string;
  billableItemAssociations: BillableItemAssociation[];
}

export const mixDesignComparer = (a: MixDesign, b: MixDesign) =>
  a.name && b.name && a.name.localeCompare(b.name);
